import styled from "styled-components";
import { MdPlayCircleOutline } from "react-icons/md";

const ItemWrapper = styled.div`
  border-radius: 8px;
`
const Item = styled.div`
  height: 12.804rem;
  border-radius: 8px;
 

  .top {
      width: 100%;
      height: 100%;
      margin: 0;
      position: relative;

      .subject-image {
        object-fit: cover;
        width: 100%;
        height: 100%;
      }
  }
`
const Overlay = styled.div`
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    background-color:rgba(0, 0, 0, 0.5);
    border-radius: 8px;
    z-index: 2;
    cursor: pointer;
    display: flex;
    align-items:center;
    justify-content: center;

    svg {
        width:4rem;
        height:4rem;
        color: white;
    }
`
const BottomText = styled.div`
    text-align: center;
    padding: 1.1rem 0;
    .subject-title {
        font-weight: 700;
        font-weight: bold;
        font-size: 1rem;
        color: #666666;
    }
`

const SubjectVideosItem = ({ subject, imgUrl, icon }) => {
    return (
        <ItemWrapper>
            <Item>

                <div className="top">
                    <Overlay><MdPlayCircleOutline /></Overlay>
                    <img className="subject-image" src={imgUrl} alt={subject} />

                </div>


            </Item>
            <BottomText >
                <span className="subject-title">{subject}</span>
            </BottomText>
        </ItemWrapper>
    )
}

export default SubjectVideosItem
